import React, { Component } from 'react';
import { Button, Col, Row } from 'reactstrap'
import Card from '../../comum/components/Card';
import FormInputSimples from '../../comum/components/FormInputSimples';
import FormDatePicker from '../../comum/components/FormDatePicker';
import SelectFiltro from '../../comum/components/SelectFiltro';
import { observer } from 'mobx-react';

@observer
export default class FiltroAnexosCdta extends Component {
    
    constructor(props) {
        super(props);

        this.controller = this.props.controller;
    }

    render() {
        return(
            <div className="filtros">
                <Card className="area-form pb-0">
                    <Row>
                        {/**
                         * Inserir um single date picker aqui
                         */}
                        <FormInputSimples
                            titulo="Container" xs={12} sm={12} md={4} lg={4} xl={2}
                            onEnter={this.controller.filtrarAnexos}
                            onChange={(event) => this.controller.setContainer(event.target.value) }
                        />
                        <FormInputSimples
                            titulo="Placa" xs={12} sm={12} md={4} lg={4} xl={2}
                            onEnter={this.controller.filtrarAnexos}
                            onChange={(event) => this.controller.setPlaca(event.target.value) }
                        />
                        <FormInputSimples
                            titulo="Booking" xs={12} sm={12} md={4} lg={4} xl={2}
                            onEnter={this.controller.filtrarAnexos}
                            onChange={(event) => this.controller.setBooking(event.target.value) }
                        />
                        <SelectFiltro xs={12} sm={12} md={4} lg={4} xl={2}
                                    titulo="Posicionamento"
                                    itens={this.controller.posicionamentos}
                                    valor={this.controller.posCntr}
                                    itensValor="value" itensLabel="label"
                                    onChange={this.controller.setPosCntr} 
                        />
                        <Col xs={12} sm={12} md={4} lg={4} xl={2} className="mb-4">
                            <div className="w-100 form-input-margin-remover adjust-size-single-date-input">
                                <FormDatePicker xs={12} sm={12} md={12} titulo="Data Atendimento"
                                    uniqueId="datAtend"
                                    onChange={ (event) => this.controller.setDataAtend(event)}
                                    date={this.controller.dataAtend}
                                />
                            </div>
                        </Col>
                        {/* <FormOnlyPositiveNumberSimples
                            titulo="CE" xs={12} sm={12} md={4} lg={4} xl={2}
                            onEnter={this.controller.baixar}
                            onChange={(event) => this.controller.setCe(event.target.value) }
                        />
                        <FormInputSimples
                            titulo="BL" xs={12} sm={12} md={4} lg={4} xl={2}
                            onEnter={this.controller.baixar}
                            onChange={(event) => this.controller.setBl(event.target.value) }
                        />
                        <FormInputSimples
                            titulo="DA" xs={12} sm={12} md={4} lg={4} xl={2}
                            onEnter={this.controller.baixar}
                            onChange={(event) => this.controller.setDa(event.target.value) }
                        />*/}
                        <Col className="col-botoes align-items-end mb-4" xl={3} lg={4} md={6} sm={12} xs={12}>
                            <Button
                                onClick={this.controller.filtrarAnexos}
                                className="btn-com-bordas-primary btn-baixar"
                            >
                                Filtrar
                            </Button>
                        </Col>
                    </Row>
                </Card>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/veiculoscdta/components/FiltroAnexosCdta.js